"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMyPropertyMyViewingState = exports.defaultMyPropertyMyListingState = void 0;
var DocumentTranslateState_init_1 = require("@/pages/document/states/DocumentTranslateState.init");
var MyPropertyTranslateState_init_1 = require("@/pages/myproperty/states/MyPropertyTranslateState.init");
var ResultPageState_init_1 = require("@/pages/search/states/ResultPageState.init");
var EformPropertyState_init_1 = require("@/pages/document/states/EformPropertyState.init");
var EformState_init_1 = require("@/pages/document/states/EformState.init");
exports.defaultMyPropertyMyListingState = {
    t: MyPropertyTranslateState_init_1.default,
    documentT: DocumentTranslateState_init_1.defaultDocumentTranslateState,
    resultT: ResultPageState_init_1.defaultResultPageTranslate,
    isLoading: false,
    eformProperties: [__assign(__assign({}, EformPropertyState_init_1.defaultEformPropertyState1), { isExpanded: false, isLoading: false, eforms: [EformState_init_1.defaultEformState1, EformState_init_1.defaultEformState2] })],
    currentPage: 1,
    totalItems: 1,
    totalPage: 1,
    keyword: '',
    suggestions: [],
    currentSuggestionIndex: -1,
    reportSoldPropertySelectedIndex: -1,
    reportSoldAgency: '',
    reportSoldLeasePrice: '',
    reportSoldSoldDate: '',
    reportSoldSoldPrice: '',
    reportSoldActive: false,
    reportSoldIsLoading: false,
    isReportSoldDateFocused: false,
    isSortActive: false,
};
exports.defaultMyPropertyMyViewingState = __assign({}, exports.defaultMyPropertyMyListingState);
